import { SHStack } from "@components/design-systems";
import { SHButton } from "../../design-systems/sh-button";
import { SHDialog } from "../../design-systems/sh-dialog";

interface LogoutDialogProps {
  open: boolean;
  onClose: () => void;
  onOk: () => void;
}

function LogoutDialog({ open, onClose, onOk }: LogoutDialogProps): JSX.Element {
  return (
    <SHDialog
      open={open}
      onClose={onClose}
      width={392}
      header="Are you sure you want to log out?"
      body="Just double checking!"
      footer={
        <SHStack
          width="100%"
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            onClick={onClose}
            variant="text"
            size="extraMedium"
          >
            Cancel
          </SHButton>
          <SHButton
            color="primary"
            size="extraMedium"
            variant="contained"
            onClick={onOk}
          >
            Yes, log me out
          </SHButton>
        </SHStack>
      }
    />
  );
}

export default LogoutDialog;
